import { GridApi } from "ag-grid-enterprise";
import { ProjectSettingType } from "context/ProjectProvider";
import { downloadStringAsCSVFile } from "utils/utils";
import { activityColDefs } from "../col-defs/activity-col-def";
import { materialColDef } from "../col-defs/material-col-def";
import { submittalColDefs } from "../col-defs/submittal-col-def";

import {
  getActivityValueGetterData,
  getLinkedMaterialGetterData,
  getLinkedSubmittalGetterData
} from "./value-getters";

export const exportActivityReportAsCSV = (
  gridRef: {
    api: GridApi;
  },
  projectDetails: ProjectSettingType | undefined
) => {
  let csvOpString = "";
  const separator = '","';

  const submittalColDef = submittalColDefs({ projectDetails });

  const headers = [
    ...activityColDefs.map((x) => x.headerName),
    materialColDef[0].headerName,
    ...materialColDef[0].children.map((x) => x.headerName),
    submittalColDef[0].headerName,
    ...submittalColDef[0].children.map((x) => x.headerName)
  ].map((x) => (x ? x.toUpperCase() : ""));

  csvOpString = `${csvOpString}"${headers.join(separator)}"`;

  gridRef?.api.forEachNodeAfterFilterAndSort((activityRowNode) => {
    if (activityRowNode.data) {
      const rowActivity = getActivityValueGetterData(activityRowNode.data);

      const { childrenMapped } = activityRowNode.data;

      if (childrenMapped) {
        const { gridRefLinkedMaterial, gridRefLinkedSubmittal } =
          childrenMapped;

        if (gridRefLinkedMaterial && gridRefLinkedMaterial.current) {
          (
            gridRefLinkedMaterial.current.api as GridApi
          ).forEachNodeAfterFilterAndSort((mRowNode) => {
            if (mRowNode.data) {
              const row = getLinkedMaterialGetterData({ data: mRowNode.data });

              const rowStrUptoMaterial = rowActivity.concat(row);
              if (
                mRowNode.data?.detailNode &&
                mRowNode.data?.detailNode?.detailGridInfo
              ) {
                const gridInfo = mRowNode.data?.detailNode.detailGridInfo;
                gridInfo.api?.forEachNodeAfterFilterAndSort((sRowNode: any) => {
                  const row2 = getLinkedSubmittalGetterData({
                    data: sRowNode.data,
                    context: { projectDetails }
                  });

                  const fullStrRow = [...rowStrUptoMaterial, ...row2];
                  csvOpString += "\n";
                  csvOpString = `${csvOpString}"${fullStrRow.join(separator)}"`;
                });
              } else {
                const fullStrRow = [
                  ...rowStrUptoMaterial,
                  "No Linked Submittal"
                ];
                csvOpString += "\n";
                csvOpString = `${csvOpString}"${fullStrRow.join(separator)}"`;
              }
            }
          });
        }

        if (gridRefLinkedSubmittal && gridRefLinkedSubmittal.current) {
          (
            gridRefLinkedSubmittal.current.api as GridApi
          ).forEachNodeAfterFilterAndSort((sRowNode) => {
            const row = getLinkedSubmittalGetterData({
              data: sRowNode.data,
              context: { projectDetails }
            });

            csvOpString += "\n";
            const materialEmptyColumns = ["", "", "", "", "", "", "", "", ""];
            const c = [...rowActivity, ...materialEmptyColumns, ...row];
            csvOpString = `${csvOpString}"${c.join(separator)}"`;
          });
        }
      }
    }
  });

  downloadStringAsCSVFile(
    csvOpString,
    `Schedule Lookahead Report_${projectDetails?.name}.csv`
  );
};
